import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../../../global/unApi";
import Authorize from "../../../global/Authorize";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";
import Header from "../../Components/MainLayout/Header";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class AttSummary extends Component {
  state = {
    dateToday: new Date(),
    dateValue: null,
    fakeData: [1, 2, 3, 4, 5, 6],
    date: new Date(),
    attendence: [],
    loading: true,
  };

  componentDidMount = () => {
    var datee = `${this.state.dateToday.getFullYear()}-${
      (this.state.dateToday.getMonth() + 1 < 10 ? "0" : "") +
      (this.state.dateToday.getMonth() + 1)
    }-${
      (this.state.dateToday.getDate() < 10 ? "0" : "") +
      this.state.dateToday.getDate()
    }`;

    this.setState({
      dateValue: `${this.state.dateToday.getFullYear()}-${
        this.state.dateToday.getMonth > 9 ? "" : "0"
      }${
        this.state.dateToday.getMonth() + 1
      }-${this.state.dateToday.getDate()}`,
    });

    this.fetchAttendence({
      date: datee,
      school: this.props.user.user.school.id,
      session: this.props.user.session.id,
    });
  };
  fetchAttendence = (params = {}) => {
    axios
      .get("/api/todaystudentclasswiseattendencecount", {
        params: { ...params },
      })
      .then((res) => {
        this.setState({ attendence: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    this.setState({ dateValue: e.target.value, loading: true });

    this.fetchAttendence({
      date: e.target.value,
      session: this.props.user.session.id,
      school: this.props.user.user.school.id,
    });
  };

  render() {
    const { dateToday } = this.state;

    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/"
      >
        <Header to="/home" title="Student Attendance" />
        <div className="container my-3 col-12">
          <div className="input-group input-group-sm my-2">
            <input
              className="form-control th-input-primary th-12"
              type="date"
              value={this.state.dateValue}
              onChange={this.handleDateChange}
              max={`${dateToday.getFullYear()}-${
                dateToday.getMonth > 9 ? "" : "0"
              }${dateToday.getMonth() + 1}-${dateToday.getDate()}`}
            />
          </div>

          {this.state.attendence?.length !== 0 && this.state.loading
            ? null
            : this.state.attendence?.map((item, i) => {
                return (
                  <div className="shadow-sm p-3 mt-2" key={i}>
                    <div className="th-14 th-medium">
                      {item.student_info__student_class__class_name}{" "}
                      {item.section_name}
                    </div>
                    <div className="th-12 d-flex justify-content-between">
                      <span className="th-medium">Total: </span>
                      {item.total_count}
                    </div>
                    <div className="th-grey">
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Present: </span>
                        {item.present_attendence_count}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Absent: </span>
                        {item.absent_attendence_count}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Half Day: </span>
                        {item.half_day_attendence_count}
                      </div>
                      <div className="th-12 d-flex justify-content-between">
                        <span className="th-medium">Late: </span>
                        {item.late_attendence_count}
                      </div>
                    </div>
                  </div>
                );
              })}
          {this.state.loading ? (
            <div>
              {this.state.fakeData.map((item, i) => {
                return (
                  <div className="shadow-sm p-3 mt-2" key={i}>
                    <Skeleton width={120} />
                    <Skeleton count={4} />
                  </div>
                );
              })}
            </div>
          ) : null}

          {this.state.attendence?.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Attendance Data Found!
              </p>
            </div>
          ) : null}
          <div style={{ height: "25vh" }}></div>
        </div>
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(AttSummary));
